angular.module('app.parametrizacionService', [
  
])

.factory('parametrizacionService', ['$http', '$q', 'appSettings','toastr', function ( $http, $q, appSettings,toastr ) {

  return {
    getMaterias: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getMaterias')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getCompetenciasA: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getCompetencias')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getTipoProcesosA: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getTipoProcesos')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getClasesA: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getClases')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getSubclasesA: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getSubclases')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getTipoAsuntoA: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getTipoAsunto')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getClasificacionesJuridicas: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getClasificacionesJuridicas')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    InsMateria: function( data ) {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Catalogos/InsMateria', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },  

    InsCompetencia: function( data ) {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Catalogos/InsCompetencia', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    InsTipoProceso: function( data ) {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Catalogos/InsTipoProceso', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    InsClase: function( data ) {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Catalogos/InsClase', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    InsSubclase: function( data ) {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Catalogos/InsSubclase', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    }, 

    InsClasificacionJuridica: function( data ) {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Catalogos/InsClasificacionJuridica', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },

    EdtMateria: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/EdtMateria', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },  

    EdtCompetencia: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/EdtCompetencia', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    EdtTipoProceso: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/EdtTipoProceso', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    EdtClase: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/EdtClase', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    EdtSubclase: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/EdtSubclase', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },     

    delMateria: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/delMateria', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },  

    delCompetencia: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/delCompetencia', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    delTipoProceso: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/delTipoProceso', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    delClase: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/delClase', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    delSubclase: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/delSubclase', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },   

    delClasificacionJuridica: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/delClasificacionJuridica', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },  

    getDepartamentos: function() {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/getDepartamentos')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getMunicipios: function(p_id_departamento) {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Departamento/'+p_id_departamento+'/getMunicipios')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getDespachos: function(p_id_departamento, p_id_municipio,p_id_competencia) {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Departamento/'+p_id_departamento+
                                                              '/Municipio/'+p_id_municipio+
                                                             '/Competencia/'+p_id_competencia+'/getDespachos')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getCompetencias: function(p_id_materia) { 
        var deferred = $q.defer();
        if(p_id_materia==null){p_id_materia=-1;}
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Materia/'+p_id_materia+'/getCompetencias')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },



    getTipoProcesos: function(p_id_materia,p_id_competencia) {
   
        var deferred = $q.defer();
        if(p_id_materia==null){p_id_materia=-1;}
        if(p_id_competencia==null){p_id_competencia=-1;}
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Materia/'+p_id_materia+'/Competencia/'+p_id_competencia+'/getTipoProcesos')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        
        return deferred.promise;

    },

    getClases: function(p_id_materia,p_id_competencia,p_id_tipo_proceso) {
        if(p_id_materia==null){p_id_materia=-1;}
        if(p_id_competencia==null){p_id_competencia=-1;}
        if(p_id_tipo_proceso==null){p_id_tipo_proceso=-1;}
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Materia/'+p_id_materia+'/Competencia/'+p_id_competencia+'/TipoProceso/'+p_id_tipo_proceso+'/getClases')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },


    getSubclases: function(p_id_materia,p_id_competencia,p_id_tipo_proceso,p_id_clase) {
        if(p_id_materia==null){p_id_materia=-1;}
        if(p_id_competencia==null){p_id_competencia=-1;}
        if(p_id_tipo_proceso==null){p_id_tipo_proceso=-1;}
        if(p_id_clase==null){p_id_clase=-1;}
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Materia/'+p_id_materia+'/Competencia/'+p_id_competencia+'/TipoProceso/'+p_id_tipo_proceso+'/Clase/'+p_id_clase+'/getSubclases')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    InsClasificacionDespacho: function( data ) {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Catalogos/InsClasificacionDespacho', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },

    getClasificacionesDespacho: function(p_id_despacho) { 
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Despacho/'+p_id_despacho+'/getClasificacionesDespacho')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    DelClasificacionDespacho: function( data ) {
        var deferred = $q.defer();
        $http.put( appSettings.restApiServiceBaseUri + 'Catalogos/DelClasificacionDespacho', data )
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    },

    /*-----------TT_CONTACTO_DESPACHO-----------*/
    insContactoCentro: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/insContactoCentro',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },

    edtContactoCentro: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/edtContactoCentro',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },

    delContactoCentro: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/delContactoCentro',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },

    getContactoCentro: function(p_id_despacho) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Transacciones/despacho/'+p_id_despacho+'/getContactoCentro')
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },
  /*-----------TT_CONTACTO_DESPACHO-----------*/
  
    //auxiliares para tableros de los servicios

    getDeptoMunicipioCentros: function(p_id_departamento,p_id_estado,p_opcion) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Departamento/'+p_id_departamento+
                                                      '/Estado/'+p_id_estado+
                                                      '/Opcion/'+p_opcion+'/getDeptoMunicipioCentros')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;
    }


  }
                                                                                                   
}]);